import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toEventWallData = (data: unknown): EventWallWorkflowData => {
    return {
        workflow: toWorkflowData(data),
        workflowType: 'event-wall',
        user: get(data, '_embedded.user'),
    }
}
